import { render, staticRenderFns } from "./jylzgMore.vue?vue&type=template&id=79a6ef7c&scoped=true&"
import script from "./jylzgMore.vue?vue&type=script&lang=js&"
export * from "./jylzgMore.vue?vue&type=script&lang=js&"
import style0 from "./jylzgMore.vue?vue&type=style&index=0&id=79a6ef7c&lang=less&scoped=true&"
import style1 from "./jylzgMore.vue?vue&type=style&index=1&id=79a6ef7c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a6ef7c",
  null
  
)

export default component.exports